// "Wedding Cake" -> "wedding-cake" (URL-safe category slug)
export const slugify = value => String(value || '')
    .normalize('NFKD').replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

// "wedding-cake" -> "Wedding Cake" (only a fallback until the real category names have loaded)
export const unslugify = slug => String(slug || '').split('-').filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

export const categoryUrl = category => (category ? `/services?category=${slugify(category)}` : '/services');
